//import Swal, { SweetAlertOptions } from "sweetalert2";
import imagen from "../../../../assets/img/fotos.png";
import { CustomToast } from "../../../../utils/custom-toast";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";

const Imagenes = ({ form, setForm }: any) => {
  const onChange = (e: any) => {
    switch (e.target.name) {
      case "images":
        {
          for (let index = 0; index < e.target.files.length; index++) {
            if (index <= 4 && form.IMAGES.length <= 5) {
              if (e.target.files[index].size > 10000000) {
                return CustomToast({
                  status: 400,
                  msg: "",
                  title: "La imagen sobrepaso el peso permitido",
                });
              } else {
                const formdata = new FormData();
                formdata.append("excursion_id", form.id);
                formdata.append("file[" + index + "]", e.target.files[index]);

                const requestOptions = {
                  method: "POST",
                  body: formdata,
                  headers: {
                    Authorization: myHeaders, // Un ejemplo de header de autenticación
                  },
                };

                fetch(`${URL_API}/excursions/upload`, requestOptions)
                  .then(async (response) => {
                    const imagesResult = await response.json();
                    const image = {
                      id: imagesResult.data[0].id,
                      url: URL.createObjectURL(e.target.files[index]),
                      file: e.target.files[index],
                      image: null,
                      imagetable_type: "",
                      imagetable_id: null,
                      created_at: "",
                    };
                    setForm({
                      ...form,
                      IMAGES: [...form.IMAGES, image],
                    });
                    CustomToast({
                      status: 200,
                      msg: "",
                      title: "Imagen creada con exito",
                    });
                  })
                  .then((result) => console.log(result))
                  .catch((error) => console.error(error));
              }
            }
          }
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "image-delete":
        {
          delete form.IMAGES[value.index];
          const images = form.IMAGES.filter((i: any) => i! != null);
          setForm({
            ...form,
            IMAGES: images,
          });

          const formdata = new FormData();
          formdata.append("id", value.id);
          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/excursions/upload-destroy`, requestOptions)
            .then(async () => {
              CustomToast({
                status: 200,
                msg: "",
                title: "Imagen eliminada con exito",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="grid lg:grid-cols-2  gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          Agregá algunas fotos
        </span>
        <div className="grid grid-cols-1 gap-5">
          <span>
            Para comenzar, vas a necesitar 5 fotos. Podés agregar otras más o
            hacer cambios más adelante.
          </span>

          <label className="border-dashed px-5 py-5 border border-black items-center ">
            <img src={imagen} alt="" className="mx-auto" width={200} />
            <div className="text-center my-4">
              <span className="block font-bold">
                Seleccioná por lo menos 5 fotos
              </span>
              <span className="border border-black border-s-0 border-t-0 border-e-0">
                Subilas desde tu dispositivo
              </span>
            </div>
            <input
              className="hidden"
              type="file"
              name="images"
              onChange={(event) => onChange(event)}
              multiple
            />
          </label>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {form.IMAGES.length > 0
          ? form.IMAGES.map((im: { url: string, id: number }, index: number) => (
              <label
                className="
              group
              cursor-pointer 
              overflow-hidden 
              p-0 
              h-[300px]
              hover:opacity-[0.9]
              hover:scale-110 transition-transform duration-300
              relative
              "
                title="Eliminar"
              >
                <img
                  src={im.url}
                  alt=""
                  className="w-full h-full"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
                <span
                  className="absolute text-white opacity-[0] 
                group-hover:opacity-[1]"
                  style={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 4,
                  }}
                >
                  Eliminar
                </span>
                <button
                  className="hidden"
                  name="image-delete"
                  onClick={(event) => onClick(event, { index: index, id: im.id })}
                ></button>
              </label>
            ))
          : null}
      </div>
    </div>
  );
};

export default Imagenes;
